import { DateTime } from "luxon";
import { YM_DATE_FORMAT } from "@/constants";

export const getNextPeriod = (from: Date = new Date()): string =>
  DateTime.fromJSDate(from).plus({ months: 1 }).toFormat(YM_DATE_FORMAT);
